import { connect } from "react-redux";
import axios from "axios";
import { useEffect, useState } from "react";

import foldWasher from "../../../../../assets/images/machines/icn-washSticker.png";
import dryerIcon from "../../../../../assets/images/machines/icn-dryer.png";
import washerIcon from "../../../../../assets/images/machines/icn-washer.png";
import { useTranslation } from "react-i18next";

const generalStamping = ({ token }) => {

    const { t } = useTranslation();

    const [washerStamp, setWasherStamp] = useState(0)
    const [dryerStamp, setDryerStamp] = useState(0)

    useEffect(() => {
        axios.get("/api/user/generalStamp", { headers: { "Content-Type": "application/json", "auth-token": token } })
            .then(res => {
                const washerGeneralStamp = res.data.generalStamps.find(stamp => stamp.type === "Washer Voucher Stamp");
                const dryerGeneralStamp = res.data.generalStamps.find(stamp => stamp.type === "Dryer Voucher Stamp");

                setWasherStamp(washerGeneralStamp?.totalStamp ?? 0);
                setDryerStamp(dryerGeneralStamp?.totalStamp ?? 0);
            })
            .catch(err => {
            })
    }, [])

    return (
        <div>
            <div className="stamp-component-cp">
                <div className="d-flex">
                    <p className="px-1 my-2" style={{ fontSize: "18px", fontWeight: 500 }}>
                        {t("Collect 3 washer stamps and 3 dryer stamps to earn RM5 Zero Massage Chair Voucher Code")}
                    </p>
                    <img
                        src={foldWasher}
                        style={{ width: "56px" }}
                        className="fit-contain pl-1"
                        alt=""
                    />
                </div>
                <div>
                    <div className="py-3">
                        <div className="d-flex">
                            <img src={washerIcon} style={{ width: "40px", padding: "3px" }} alt="" />
                            <p className="ml-1 font-weight-bold" style={{ marginTop: "auto", marginBottom: "auto", fontSize: "16px" }}>{t("Wash")}</p>
                            <p style={{ marginLeft: "auto", marginBottom: "auto", marginTop: "auto", fontSize: "16px" }}>{washerStamp}/3</p>
                        </div>
                        <progress id="progress-bar" value={washerStamp} max="3"></progress>
                    </div>
                    <div className="py-3">
                        <div className="d-flex">
                            <img src={dryerIcon} style={{ width: "40px" }} alt="" />
                            <p className="ml-1 font-weight-bold" style={{ marginTop: "auto", marginBottom: "auto", fontSize: "16px" }}>{t("Dry")}</p>
                            <p style={{ marginLeft: "auto", marginBottom: "auto", marginTop: "auto", fontSize: "16px" }}>{dryerStamp}/3</p>
                        </div>
                        <progress id="progress-bar" value={dryerStamp} max="3"></progress>
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        token: state.user.token,
    };
};

export default connect(mapStateToProps, null)(generalStamping);